module.exports={
  "name": "stack-chain",
  "description": "API for combining call site modifiers",
  "version": "1.3.2",
  "author": {
    "name": "Andreas Madsen",
    "email": "amwebdk@gmail.com"
  },
  "main": "./stack-chain.js",
  "scripts": {
    "test": "tap ./test/simple"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/AndreasMadsen/stack-chain.git"
  },
  "keywords": [
    "stack",
    "chain",
    "trace",
    "call site",
    "concat",
    "format"
  ],
  "devDependencies": {
    "tap": "0.4.x"
  },
  "license": "MIT",
  "gitHead": "e5e3c4e20938f43620764ef57e17b2cbbb5af0e9",
  "bugs": {
    "url": "https://github.com/AndreasMadsen/stack-chain/issues"
  },
  "homepage": "https://github.com/AndreasMadsen/stack-chain#readme",
  "_id": "stack-chain@1.3.2",
  "_shasum": "ef567d924725c310d483877648908176d36f811a",
  "_from": "stack-chain@>=1.3.1 <2.0.0",
  "_npmVersion": "2.9.0",
  "_nodeVersion": "2.0.1",
  "_npmUser": {
    "name": "andreasmadsen",
    "email": "amwebdk@gmail.com"
  },
  "maintainers": [
    {
      "name": "andreasmadsen",
      "email": "amwebdk@gmail.com"
    }
  ],
  "dist": {
    "shasum": "ef567d924725c310d483877648908176d36f811a",
    "tarball": "http://registry.nodejitsu.com/stack-chain/-/stack-chain-1.3.2.tgz"
  },
  "directories": {},
  "_resolved": "http://registry.nodejitsu.com/stack-chain/-/stack-chain-1.3.2.tgz"
}
